"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Canvas = void 0;
class Canvas {
    constructor() {
        this.canvas = document.getElementById("canvas");
        this.ctx = this.canvas.getContext("2d");
        this.setScreenSize();
    }
    draw(bubbles) {
        this.setScreenSize();
        bubbles.forEach(bubble => this.drawBubble(bubble));
    }
    setScreenSize() {
        this.canvas.width = window.innerWidth;
        this.canvas.height = window.innerHeight;
    }
    drawBubble(bubble) {
        if (bubble.heat > 3) {
            this.ctx.beginPath();
            this.ctx.arc(bubble.position.x, bubble.position.y, bubble.heat - 3, 0, 2 * Math.PI);
            this.ctx.fillStyle = bubble.colour;
            this.ctx.fill();
        }
    }
}
exports.Canvas = Canvas;
//# sourceMappingURL=canvas.js.map